<app-header></app-header>
<div class="content my-5">
    <div class="container-fluid my-5" style="padding-bottom: 15rem">
        <router-outlet></router-outlet>
    </div>
</div>
